import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { QueryKeys } from '../constants';
import { MissingIdError, useFetch } from './utils';

// eslint-disable-next-line import/prefer-default-export
export const useDismissSuggestedThemes = () => {
  const fetcher = useFetch();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ codeFrameId, suggestedThemeIds }) => {
      if (!codeFrameId) {
        throw new MissingIdError('codeFrameId');
      }
      return fetcher({ path: `v1/llm/${suggestedThemeIds.join()}/dismiss/`, method: 'PUT' });
    },
    onSettled: (_data, _error, { codeFrameId }) =>
      queryClient.invalidateQueries([QueryKeys.SUGGESTED_THEMES, { codeFrameId }]),
    onError: () => {
      message.error('Something went wrong dismissing suggested themes');
    },
  });
};
